import { Locale } from "./config";

export interface Metadata {
    title: string;
    description: string;
}

export const metadataTranslations: Record<string, Record<Locale, Metadata>> = {
    default: {
        fi: {
            title: "Digihappy | Senioripuhelin, senioritabletti ja turvaranneke palveluna",
            description: "Helppo senioritabletti palveluna. Videopuheluapilla puhelut ilman kosketusta. Turvaranneke ja senioripuhelin palveluna. IT-tuki."
        },
        en: {
            title: "Digihappy | Senior Phone, Senior Tablet, and Safety Bracelet as a service",
            description: "Easy senior tablet service. Hands-free video calls with the video call app. Safety bracelet and senior phone as a service. IT support."
        },
        sv: {
            title: "Digihappy | Seniortelefon, seniorplatta och trygghetslarm som tjänst",
            description: "Enkel seniorsurfplatta som tjänst. Videosamtal utan beröring med videosamtalsapp. Trygghetslarm och seniortelefon som tjänst. IT-support."
        }
    },
    home: {
        fi: {
            title: "Digihappy | Senioripuhelin, senioritabletti ja turvaranneke palveluna",
            description: "Helppo senioritabletti palveluna. Videopuheluapilla puhelut ilman kosketusta. Turvaranneke ja senioripuhelin palveluna. IT-tuki."
        },
        en: {
            title: "Digihappy | Senior Phone, Senior Tablet, and Safety Bracelet as a service",
            description: "Easy senior tablet service. Hands-free video calls with the video call app. Safety bracelet and senior phone as a service. IT support."
        },
        sv: {
            title: "Digihappy | Seniortelefon, seniorplatta och trygghetslarm som tjänst",
            description: "Enkel seniorsurfplatta som tjänst. Videosamtal utan beröring med videosamtalsapp. Tygghetslarm och seniortelefon som tjänst. IT-support."
        }
    },
    videoCallApp: {
        fi: {
            title: "Videopuhelu Appi | Helppo ja turvallinen yhteys | Digihappy",
            description: "Digihappy Videopuhelu Appi seniorille ja läheisille. Videopuhelut ilman kosketusta. Turvallinen perhetili. Kokeile 14 päivää maksutta."
        },
        en: {
            title: "Video Call App | Easy and Secure Connection | Digihappy",
            description: "Digihappy Video Call App for seniors and relatives. Video calls can open without touch. Secure family account. Try free for 14 days."
        },
        sv: {
            title: "Videosamtal App | Enkel och säker kontakt | Digihappy",
            description: "Digihappy Videosamtal App för äldre och anhöriga. Videosamtal kan öppnas utan beröring. Säkert familjekonto. Prova gratis i 14 dagar."
        }
    },
    services: {
        fi: {
            title: "Senioritabletti palveluna | Helpot videopuhelut | Digihappy",
            description: "Helppo senioritabletti palveluna. Videopuhelut ilman kosketusta. Hauskaa tekemistä. Helpot apit valmiina. IT-tuki."
        },
        en: {
            title: "Senior Tablet as a Service | Easy Video Calls | Digihappy",
            description: "Easy senior tablet as a service. Hands-free video calls. Fun activities. Easy apps ready to use. IT support."
        },
        sv: {
            title: "Seniorsurfplatta som tjänst | Enkla videosamtal | Digihappy",
            description: "Enkel seniorsurfplatta som tjänst. Videosamtal utan beröring. Roliga aktiviteter. Enkla appar färdiga att använda. IT-support."
        }
    },
    phone: {
        fi: {
            title: "Senioripuhelin palveluna | Helpot ominaisuudet | Digihappy",
            description: "Helppo senioripuhelin palveluna. Tarpeelliset ominaisuudet ja videopuhelut valmiina. IT-tuki."
        },
        en: {
            title: "Senior Phone as a Service | Easy Features | Digihappy",
            description: "Easy senior phone as a service. Essential features and video calls ready to use. IT support."
        },
        sv: {
            title: "Seniortelefon som tjänst | Enkla funktioner | Digihappy",
            description: "Enkel seniortelefon som tjänst. Viktiga funktioner och videosamtal färdiga att använda. IT-support."
        }
    },
    watch: {
        fi: {
            title: "Turvaranneke vanhukselle | GPS ja hälytys | Digihappy",
            description: "Turvaranneke seniorille palveluna. GPS-paikannus, hälytyspainike, kaatumishälytys. Puheyhteys. Helppo älykello- tai rannekemalli. IT-tuki."
        },
        en: {
            title: "Safety Bracelet for Seniors | GPS and alarm | Digihappy",
            description: "Safety bracelet service for seniors. GPS tracking, alarm button, fall detection. Voice connection. Easy smartwatch or bracelet model. IT support."
        },
        sv: {
            title: "Trygghetslarm för äldre | GPS och larm | Digihappy",
            description: "Trygghetslarm för seniorer som tjänst. GPS-positionering, larmknapp, fallarm. Talförbindelse. Enkel smartklocka eller armbandsmodell. IT-support."
        }
    },
    forCompanies: {
        fi: {
            title: "Turvarannekkeet ja tablettipalvelut hoivapalveluihin | Digihappy",
            description: "Modernit turvarannekkeet ja tabletit hoivapalveluihin. GPS-paikannus, hälytykset. Etähoivan videopuhelut, aktiviteetit, kirjaaminen. IT-tuki."
        },
        en: {
            title: "Safety Bracelets and Tablet Services for Care Providers | Digihappy",
            description: "Modern safety bracelets and tablets for care providers. GPS tracking, alarms. Remote care video calls, activities, documentation. IT support."
        },
        sv: {
            title: "Trygghetslarm och surfplattetjänster för vård och omsorg | Digihappy",
            description: "Moderna trygghetslarm och surfplattor för vård och omsorg. GPS-positionering, larm. Videosamtal för distansvård, aktiviteter, dokumentation. IT-support."
        }
    },
    osta: {
        fi: {
            title: "Osta | Digihappy",
            description: "Osta senioritabletti, videopuheluappi, turvaranneke tai senioripuhelin. Kaikki valmiina palveluna ja IT-tuki."
        },
        en: {
            title: "Buy | Digihappy",
            description: "Buy a senior tablet, video call app, safety bracelet or senior phone. Ready-to-use services with IT support."
        },
        sv: {
            title: "Köp | Digihappy",
            description: "Köp seniorsurfplatta, videosamtalsapp, trygghetslarm eller seniortelefon. Färdiga tjänster med IT-support."
        }
    },
    products_tablet: {
        fi: {
            title: "Osta senioritabletti palveluna | Digihappy",
            description: "Osta helppo senioritabletti palveluna. Videopuhelut ilman kosketusta. Hauskaa tekemistä. Helpot apit valmiina. IT-tuki."
        },
        en: {
            title: "Buy Senior Tablet as a Service | Digihappy",
            description: "Buy easy senior tablet as a service. Hands-free video calls. Fun activities. Easy apps ready to use. IT support."
        },
        sv: {
            title: "Köp seniorsurfplatta som tjänst | Digihappy",
            description: "Köp en enkel seniorsurfplatta som tjänst. Videosamtal utan beröring. Roliga aktiviteter. Enkla appar färdiga att använda. IT-support."
        }
    },
    products_phone: {
        fi: {
            title: "Osta senioripuhelin palveluna | Digihappy",
            description: "Osta helppo senioripuhelin palveluna. Tarpeelliset ominaisuudet ja videopuhelut valmiina. IT-tuki."
        },
        en: {
            title: "Buy Senior Phone as a Service | Digihappy",
            description: "Buy easy senior phone as a service. Essential features and video calls ready to use. IT support."
        },
        sv: {
            title: "Köp seniortelefon som tjänst | Digihappy",
            description: "Köp en enkel seniortelefon som tjänst. Viktiga funktioner och videosamtal färdiga att använda. IT-support."
        }
    },
    products_alarm: {
        fi: {
            title: "Osta turvaranneke | Digihappy",
            description: "Osta turvaranneke seniorille palveluna. GPS-paikannus, hälytyspainike, kaatumishälytys. Puheyhteys. Helppo älykello- tai rannekemalli. IT-tuki."
        },
        en: {
            title: "Buy Safety Bracelet | Digihappy",
            description: "Buy a safety bracelet service for seniors. GPS tracking, alarm button, fall detection. Voice connection. Easy smartwatch or bracelet model. IT support."
        },
        sv: {
            title: "Köp trygghetslarm | Digihappy",
            description: "Köp trygghetslarm för seniorer som tjänst. GPS-positionering, larmknapp, fallarm. Talförbindelse. Enkel smartklocka eller armbandsmodell. IT-support."
        }
    },
    products_accessories: {
        fi: {
            title: "Osta lisätarvikkeet | Digihappy",
            description: "Osta Digihappy-lisätarvikkeet senioritablettiin, turvarannekkeeseen ja senioripuhelimeen."
        },
        en: {
            title: "Buy Accessories | Digihappy",
            description: "Buy Digihappy accessories for senior tablets, safety bracelets, and senior phones."
        },
        sv: {
            title: "Köp tillbehör | Digihappy",
            description: "Köp Digihappy-tillbehör till seniorsurfplattor, trygghetslarm och seniortelefoner."
        }
    },
    products_app: {
        fi: {
            title: "Osta Videopuhelu Appi | Digihappy",
            description: "Osta helppo videopuheluappi senioreille ja läheisille. Puhelut voivat avautua ilman kosketusta. Turvallinen perhetili. Kokeile 14 päivää maksutta."
        },
        en: {
            title: "Buy Video Call App | Digihappy",
            description: "Buy an easy video call app for seniors and relatives. Calls can open automatically. Secure family account. Try free for 14 days."
        },
        sv: {
            title: "Köp Videosamtal App | Digihappy",
            description: "Köp en enkel videosamtalsapp för äldre och anhöriga. Samtal kan öppnas automatiskt. Prova gratis i 14 dagar."
        }
    },
    contact: {
        fi: {
            title: "Ota yhteyttä | Digihappy",
            description: "Ota yhteyttä. Autamme mielellämme sinua ja läheisiäsi."
        },
        en: {
            title: "Contact Us | Digihappy",
            description: "Contact us. We are happy to help you and your loved ones."
        },
        sv: {
            title: "Kontakta oss | Digihappy",
            description: "Kontakta oss. Vi hjälper gärna dig ja dina anhöriga."
        }
    },
    faq: {
        fi: {
            title: "Usein kysytyt kysymykset | Digihappy",
            description: "Vastauksia kysymyksiin senioritableteista, videopuheluista, perheyhteydestä, hinnoista, käyttöönotosta, etähoidosta, tablettipalveluista ja IT-tuesta."
        },
        en: {
            title: "Frequently Asked Questions | Digihappy",
            description: "Find answers about senior tablets, video calls, family connection, pricing, setup, remote care, tablet services, and IT support."
        },
        sv: {
            title: "Vanliga frågor | Digihappy",
            description: "Svar på frågor om seniorsurfplattor, videosamtal, familjekontakt, priser, installation, distansvård, surfplattetjänster och IT-support."
        }
    },
    termsOfUse: {
        fi: {
            title: "Digihappy palveluehdot ja tietosuoja | Digihappy",
            description: "Digihappy palveluehdot ja tietosuoja. Hyvä palvelu ja tietosuoja ovat meille aidosti tärkeitä."
        },
        en: {
            title: "Digihappy Terms of Service and Privacy Policy | Digihappy",
            description: "Digihappy terms of service and privacy policy. Good service and privacy are genuinely important to us."
        },
        sv: {
            title: "Digihappy Användarvillkor och Integritetspolicy | Digihappy",
            description: "Digihappy användarvillkor och integritetspolicy. Bra service och integritet är genuint viktiga för oss."
        }
    },
    aboutUs: {
        fi: {
            title: "Meistä | Digihappy",
            description: "Digihappy on suomalainen yritys, joka tekee helppoja digipalveluja senioreille, perheille ja yrityksille. Tutustu tarinaan, tiimiin ja aitoihin kokemuksiin."
        },
        en: {
            title: "About Us | Digihappy",
            description: "Digihappy is a Finnish company creating easy digital services for seniors, families and companies. Learn about our story, team, and customer experiences."
        },
        sv: {
            title: "Om oss | Digihappy",
            description: "Digihappy är ett finländskt företag som skapar enkla digitaler tjänster för äldre, familjer och företag. Läs om vår historia, vårt team och kundupplevelser."
        }
    },
    blog_list: {
        fi: {
            title: "HappySenior Blogi - Vinkkejä ja tarinoita ikäihmisten arkeen | Digihappy",
            description: "Blogi seniorin terveydestä ja hyvinvoinnista. Ja vinkkejä iloiseen tabletin käyttöön. Lääketieteen, hyvinvoinnin ja digin ammattilaiset kirjoittajina."
        },
        en: {
            title: "HappySenior Blog - Tips & Stories for Seniors' Daily Life | Digihappy",
            description: "Blog on seniors' health, well-being, and tips for joyful tablet use. Written by medical, wellness, and digital experts."
        },
        sv: {
            title: "HappySenior Blogg - Tips & berättelser för äldres vardag | Digihappy",
            description: "Blogg om äldres hälsa, välbefinnande och tips för glad surfplatteanvändning. Skriven av experter inom medicin, wellness och digital teknik."
        }
    },
    memory_game: {
        fi: {
            title: "Ilmainen Muistipeli Senioreille | Happy Memory Game",
            description: "Pelaa hauskaa ja ilmaista muistipeliä! Kehitetty erityisesti ikäihmisten ja muistisairaiden aivojen aktivoimiseen ja hauskanpitoon."
        },
        en: {
            title: "Free Memory Game for Seniors | Happy Memory Game",
            description: "Play a fun and free memory game! Specially designed to keep seniors' brains active and entertained."
        },
        sv: {
            title: "Gratis minnesspel för äldre | Happy Memory Game",
            description: "Spela ett roligt och gratis minnesspel! Speciellt utformat för att hålla äldres hjärnor aktiva och underhållna."
        }
    },
    copyright: {
        fi: {
            title: "Tietosuojaseloste | Digihappy",
            description: "Digihappy tietosuojaseloste. Käsittelemme henkilötietojasi huolellisesti, turvallisesti ja lakia noudattaen."
        },
        en: {
            title: "Privacy Policy | Digihappy",
            description: "Digihappy privacy policy. We handle your personal data carefully, securely, and in compliance with regulations."
        },
        sv: {
            title: "Integritetspolicy | Digihappy",
            description: "Digihappy integritetspolicy. Vi hanterar dina personuppgifter noggrant, säkert och i enlighet med lagstiftningen."
        }
    },
    login: {
        fi: {
            title: "Kirjaudu sisään | Digihappy",
            description: "Kirjaudu sisään Digihappy-tilillesi hallinnoidaksesi palveluita, laitteita ja perheyhteyksiä."
        },
        en: {
            title: "Log In | Digihappy",
            description: "Log in to your Digihappy account to manage your services, devices, and family connections."
        },
        sv: {
            title: "Logga in | Digihappy",
            description: "Logga in på ditt Digihappy-konto för att hantera dina tjänster, enheter och familjeanslutningar."
        }
    },
    thanks: {
        fi: {
            title: "Kiitos tilauksestasi! | Digihappy",
            description: "Kiitos tilauksestasi. Olemme vastaanottaneet tilauksesi ja käsittelemme sen mahdollisimman pian."
        },
        en: {
            title: "Thank You for Your Order! | Digihappy",
            description: "Thank you for your order. We have received your order and will process it as soon as possible."
        },
        sv: {
            title: "Tack för din beställning! | Digihappy",
            description: "Tack för din beställning. Vi har tagit emot din beställning och kommer att behandla den så snart som möjligt."
        }
    }
};
